import { ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT, ARROW_UP } from './keyboard';

export const FOCUSABLE_SELECTOR = 'a, button, input, textarea, select, [tabindex]';
export function getFocusableChildren(
  parent: HTMLElement | null | undefined,
  selector = FOCUSABLE_SELECTOR,
) {
  return [...(parent?.querySelectorAll(selector) || [])].filter<HTMLElement>(
    (element): element is HTMLElement => {
      const { visibility, display } = window.getComputedStyle(element);
      return (
        element instanceof HTMLElement &&
        !element.getAttribute('disabled') &&
        element.tabIndex !== -1 &&
        visibility !== 'hidden' &&
        display !== 'none' &&
        !element.inert
      );
    },
  );
}

export const FocusDirection = {
  FORWARD: [ARROW_RIGHT, ARROW_DOWN],
  BACKWARD: [ARROW_LEFT, ARROW_UP],
};
